import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SchedulingWindowPipe} from './scheduling-window.pipe';

@NgModule({
    declarations: [SchedulingWindowPipe],
    imports: [
        CommonModule
    ],
    exports: [SchedulingWindowPipe]
})
export class SchedulingWindowsModule { }
